import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import data from '../../assets/data/ver-category';
import VerGrammageDatatable from '../common/ver-grammage-datatable';
import Modal from 'react-responsive-modal';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import Select from 'react-select';

// image import
import img_grammage from '../../assets/images/example/primera_caracteristica.png'

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

export class Ver_grammage extends Component {
    constructor(props) {
        super(props);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeColor = this.onChangeColor.bind(this);
        this.onChangeTitleColor = this.onChangeTitleColor.bind(this);
        this.onChangeTextColor = this.onChangeTextColor.bind(this);
        this.onChangeColor2 = this.onChangeColor2.bind(this);
        this.onChangeBackground = this.onChangeBackground.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);
        //this.handleFile = this.handleFile.bind(this);
        this.handler = this.handler.bind(this);
        this.state = {
            selectedCategOption: null,
            open: false,
            open_example: false,
            register: true,
            id: "",
            name: "",
            color: "",
            text_color: "",
            title_color: "",
            color_2: "",
            errors: {},
            selectedTemplateOption: null,
            data_template: [
              {value: 'TIPO1',label: 'THC'},
              {value: 'TIPO2',label: 'SEEDS'},
              {value: 'TIPO3',label: 'SATIVA'},
            ],
            status: "ACTIVATED",
            background_url: "",
            file: null,
            loading: false,
            message: "",
            results: [],
            file_backup:null,
            flag_validate_image: false,
            data_categ_parent: []
        };
    }

    handler(data_row) {
        this.setState({ name: data_row.original.data.name });
        this.setState({ id: data_row.original.data.id });
        this.setState({ register: false });
        this.setState({ file: {name : data_row.original.data.image} });
        this.setState({ file_backup: data_row.original.data.image });
        for (let i = 0; i < this.state.data_template.length; i++){
          if(this.state.data_template[i]['value'] === data_row.original.data.type){
              this.handleTemplateChange(this.state.data_template[i])
          }
        }

        this.setState({ open: true });
    }

    onChangeName(e) {
        this.setState({
            name: e.target.value
        });
      }
    
    onChangeColor(e) {
        this.setState({
            color: e.target.value
        });
    }

    onChangeTitleColor(e) {
      this.setState({
          title_color: e.target.value
      });
    }

    onChangeTextColor(e) {
      this.setState({
          text_color: e.target.value
      });
    }

    onChangeColor2(e) {
      this.setState({
          color_2: e.target.value
      });
    }

    onChangeBackground(e) {
        this.setState({
            background_url: e.target.value
        });
    }

    onChangeStatus(e) {
        this.setState({
            status: e.target.value
        });
      }

    handleFile(e){
        let file = e.target.files[0];
        this.setState({file: e.target.files[0]}, () => {
        })
        //this.setState(() => ({ file })); 
        /*this.setState({
            file: e.target.files[0]
        });*/
    }

    handleCategChange = selectedCategOption => {
      this.setState(
        { selectedCategOption },
        () => {
        }
      );
    };

    componentWillMount() {
      this.getDataGrammage();
    }

    clearInputs() {
      this.setState({
          register: true,
          id: "",
          name: "",
          color: "",
          color_2: "",
          title_color: "",
          text_color: "",
          status: "ACTIVATED",
          background_url: "",
          file: null,
          loading: false,
          message: "",
          //results: [],
          file_backup:null,
          flag_validate_image: false,
      });
    }

    showStatus(results){
    // Aplicamos un fix si no devuelve una imagen 
    let url_image = `${process.env.REACT_APP_URL_FILES}images/grammage/`;
		for (let i = 0; i < results.length; i++){
			/*if( (results[i]['status'] === 'ACTIVATED') ){
				results[i]['estado'] = <i className="fa fa-circle font-success f-12"/>;
			}else{
				results[i]['estado'] = <i className="fa fa-circle font-danger f-12"/>;
      }*/
      results[i]['imagen'] = results[i]['image']?<img src={url_image + results[i]['image']} style={{width:50,height:50}}/>:'';
		}
		return results;
	}

    getDataGrammage(){
        var user = AuthService.getCurrentUser();
        ApiService.getDataGrammage(user.token,0).then(
            (res) => {
              if(res && res.status == 'success'){
                this.setState({ results:[] });
                let itemsGrammage = []
                this.showStatus(res.data).map((row,index) =>{
                  itemsGrammage.push(row);
                })

                const items = itemsGrammage.map(function(row) {
                  let tipo = '';
                  switch (row.type) {
                    case 'TIPO1':
                        tipo = 'THC';
                      break;
                    case 'TIPO2':
                        tipo = 'SEEDS';
                      break;
                    default:
                        tipo = 'SATIVA';
                      break;
                  }
                  return { 
                    '#': row.id,
                    Imagen: row.imagen, 
                    id: row.id, 
                    Nombre : row.name, 
                    Tipo: tipo,
                    data: row
                  }
               })

              this.setState({ results:items });
              this.renderResults();
              //this.componentShouldUpdate()
              }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderResults(){
		return this.state.results.length === 0 
			? ''
			: <VerGrammageDatatable
                    multiSelectOption={false}
                    myData={this.state.results}
                    pageSize={this.state.results.length<=50?this.state.results.length:50}
                    pagination={true}
                    class="-striped -highlight"
                    handler = {this.handler}
                />
	}


    handleRegister(e) {
        //e.preventDefault();
    
        this.setState({
          message: "",
          loading: true
        });
    
        this.form.validateAll();

        if(!this.state.selectedTemplateOption){
          this.setState({
              errors: {template : "Error"}
          }) 
        }else{
            this.setState({
                errors: {template : ""}
            }) 
        }
    
        if (this.checkBtn.context._errors.length === 0 && !this.state.errors.template) {
            this.onCloseModal('VaryingMdo');
            var user = AuthService.getCurrentUser();
            let formdata = new FormData()
            formdata.append('name', this.state.name)
            //formdata.append('color', this.state.color?this.state.color:'')
            //formdata.append('color_2', this.state.color_2?this.state.color_2:'')
            //formdata.append('text_color', this.state.text_color?this.state.text_color:'')
            //formdata.append('title_color', this.state.title_color?this.state.title_color:'')
            formdata.append('image', this.state.file)
            formdata.append('type', this.state.selectedTemplateOption.value)
            ApiService.postGrammge(user.token,formdata).then(
            (res) => {
                if(res && res.status == 'success'){
                  toast.success("Gramaje creado!");
                  this.getDataGrammage();
                  this.clearInputs();
                  //this.props.history.push("/category");
                  //window.location.reload();
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
    
              this.setState({
                loading: false,
                message: resMessage
              });
            }
          );
        } else {
          this.setState({
            loading: false
          });
        }
      }

      handleUpdate(e) {
        //e.preventDefault();
        this.setState({
          message: "",
          loading: true
        });
    
        this.form.validateAll();

        if(!this.state.selectedTemplateOption){
          this.setState({
              errors: {template : "Error"}
          }) 
        }else{
            this.setState({
                errors: {template : ""}
            }) 
        }
    
        if (this.checkBtn.context._errors.length === 0 && !this.state.errors.template) {
            this.onCloseModal('VaryingMdo');
            var user = AuthService.getCurrentUser();
            let formdata = new FormData()
            formdata.append('id_grammage', this.state.id)
            formdata.append('name', this.state.name)
            if(this.state.file_backup != this.state.file.name)
            {
              formdata.append('image', this.state.file)
            }
            formdata.append('type', this.state.selectedTemplateOption.value)
            ApiService.updateGrammage(user.token,formdata).then(
            (res) => {
                if(res && res.status == 'success'){
                  toast.success("Gramaje actualizada!");
                  this.clearInputs();
                  this.getDataGrammage();
                  //this.props.history.push("/category");
                  //window.location.reload();
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
    
              this.setState({
                loading: false,
                message: resMessage
              });
            }
          );
        } else {
          this.setState({
            loading: false
          });
        }
      }

    onOpenModal = () => {
        this.setState({ register: true });
        this.setState({ open: true });
    };

    onClearData = () => {
      this.clearInputs();
      this.onOpenModal();
  };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    handleTemplateChange = selectedTemplateOption => {
      this.setState(
        { selectedTemplateOption },
        () => {
        }
      );
    };

    // componentWillReceiveProps(){
    //     this.getDataGrammage()
    // }

    onShowExample = (img) => {
      this.setState({ open_example: true });
      this.setState({
        img_example: img
      }, function () {
      });
    };

    onCloseExample = () => {
      this.setState({ open_example: false });
    };


    render() {
        const { open, open_example } = this.state;
        const { selectedTemplateOption } = this.state;
        const { selectedCategOption } = this.state;

        return (
            <Fragment>
                <Breadcrumb title="Gramajes" parent="Digital" />
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Gramajes</h5>
                                </div>
                                <div className="card-body">
                                    <div className="btn-popup pull-right">
                                        <button type="button" className="btn btn-secondary" onClick={this.onClearData} data-toggle="modal" data-original-title="test" data-target="#exampleModal">Añadir Gramaje</button>
                                        <Modal open={open} onClose={this.onCloseModal} >
                                            <div className="modal-header">
                                                <h5 className="modal-title f-w-600" id="exampleModalLabel2">Añadir Gramaje</h5>
                                            </div>
                                            <Form 
                                            id="frmCateg"
                                            //onSubmit={this.state.register?this.handleRegister:this.handleUpdate} 
                                            encType="multipart/form-data" 
                                            method="POST"
                                            ref={c => {this.form = c;
                                            }}>
                                            <div className="modal-body">
                                              <div className="row">
                                                <div className="col-md-12">
                                                  <div className="form-group" hidden="1">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Id:</label>
                                                        <Input 
                                                        name="id" 
                                                        value={this.state.id} 
                                                        type="text" 
                                                        className="form-control" 
                                                        />
                                                        {/*<input type="text" className="form-control" />*/}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Nombre:</label>
                                                        <Input 
                                                        name="name" 
                                                        value={this.state.name} 
                                                        type="text" 
                                                        className="form-control" 
                                                        onChange={this.onChangeName}
                                                        validations={[required]}
                                                        />
                                                        {/*<input type="text" className="form-control" />*/}
                                                    </div>
                                                    {/*<div className="form-group">
                                                        <label className="col-form-label">Estado:</label>
                                                        <div className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                                            <label className="d-block d-block-status d-block-left">
                                                            <Input 
                                                                id="edo-ani"
                                                                name="status" 
                                                                value="ACTIVATED"
                                                                type="radio" 
                                                                className="radio_animated radio_status" 
                                                                checked={this.state.status === "ACTIVATED"}
                                                                onChange={this.onChangeStatus}
                                                                validations={[required]}
                                                            />
                                                            Activo
                                                        </label>
                                                            <label className="d-block d-block-status" >
                                                            <Input 
                                                                id="edo-ani"
                                                                name="status" 
                                                                value="DESACTIVATED"
                                                                type="radio" 
                                                                className="radio_animated radio_status" 
                                                                checked={this.state.status === "DESACTIVATED"}
                                                                onChange={this.onChangeStatus}
                                                                validations={[required]}
                                                            />
                                                            Inactivo
                                                        </label>
                                                        </div>
                                                    </div>*/}
                                                    <div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Tipo:</label>
                                                        <Select
                                                            value={selectedTemplateOption}
                                                            onChange={this.handleTemplateChange}
                                                            options={this.state.data_template}
                                                        />
                                                        {
                                                        this.state.errors.template && !this.state.selectedTemplateOption?
                                                        <div className="alert alert-danger" role="alert" >Este campo es obligatorio!</div>
                                                        :''}
                                                        {/*<input type="text" className="form-control" />*/}
                                                    </div>
                                                    {/*<div className="form-group">
                                                        <label className="col-form-label">Categoría Parent:</label>
                                                        <Select
                                                            value={selectedCategOption}
                                                            onChange={this.handleCategChange}
                                                            options={this.state.data_categ_parent}
                                                        />
                                                    </div>*/}
                                                    <div className="form-group">
                                                        <label htmlFor="message-text" className="col-form-label">Imagen (300 x 300): <span onClick={(event) => this.onShowExample( 'img_grammage')}><b>(?)</b></span></label>
                                                        <Input 
                                                        name="background_url" 
                                                        //value={this.state.file} 
                                                        type="file" 
                                                        className="form-control" 
                                                        accept="image/*"
                                                        validations={this.state.register?[required]:[]}
                                                        //onChange={this.onChangeBackground}
                                                        //onChange={(e)=>this.handleFile(e)}
                                                        onChange={(e) => {
                                                            this.setState({file: e.target.files[0]}, () => {
                                                            })
                                                            }}
                                                        />
                                                        {/*<input className="form-control" id="validationCustom02" type="file" />*/}
                                                    </div>
                                                    {/*<div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Color de fondo 1:</label>
                                                        <Input 
                                                        name="color" 
                                                        value={this.state.color} 
                                                        type="text" 
                                                        className="form-control" 
                                                        onChange={this.onChangeColor}
                                                        validations={[required]}
                                                        />
                                                    </div>*/}
                                                    {/*<div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Color de fondo 2:</label>
                                                        <Input 
                                                        name="color" 
                                                        value={this.state.color_2} 
                                                        type="text" 
                                                        className="form-control" 
                                                        onChange={this.onChangeColor2}
                                                        />
                                                    </div>*/}
                                                    {/*<div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Color de Título:</label>
                                                        <Input 
                                                        name="color" 
                                                        value={this.state.title_color} 
                                                        type="text" 
                                                        className="form-control" 
                                                        onChange={this.onChangeTitleColor}
                                                        validations={[required]}
                                                        />
                                                    </div>*/}
                                                    {/*<div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >Color de Texto:</label>
                                                        <Input 
                                                        name="color" 
                                                        value={this.state.text_color} 
                                                        type="text" 
                                                        className="form-control" 
                                                        onChange={this.onChangeTextColor}
                                                        validations={[required]}
                                                        />
                                                  </div>*/}                                                
                                                  </div>
                                              </div>
                                            </div>
                                            <div className="modal-footer">
                                            <Link
                                                to={`${process.env.PUBLIC_URL}/grammage`}
                                                onClick={() => this.state.register?this.handleRegister():this.handleUpdate()}
                                            >
                                                <button 
                                                        className="btn btn-primary"  
                                                        disabled={this.state.loading}
                                                        >
                                                        {this.state.loading && (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        )}
                                                        <span>Guardar</span>
                                                </button> 
                                            </Link>
                                                {/*<button type="button" className="btn btn-primary" onClick={() => this.onCloseModal('VaryingMdo')}>Guardar</button>*/}
                                                <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal('VaryingMdo')}>Cancelar</button>
                                            </div>
                                            {this.state.message && (
                                            <div className="form-group">
                                                <div className="alert alert-danger" role="alert">
                                                {this.state.message}
                                                </div>
                                            </div>
                                            )}
                                            <CheckButton
                                            style={{ display: "none" }}
                                            ref={c => {
                                                this.checkBtn = c;
                                            }}
                                            />
                                            </Form>
                                        </Modal>
                                        <Modal open={open_example} onClose={this.onCloseExample} >
                                            <div className="modal-header">
                                                <h5 className="modal-title f-w-600" id="exampleModalLabel2">Ejemplo</h5>
                                            </div>
                                            <div className="modal-body">
                                              <div className="row">
                                                <div style={{ margin: '0 auto' }}>
                                                  <div className="form-group">
                                                  {
                                                    this.state.img_example == 'img_grammage'?
                                                    <img className="blur-up lazyloaded" src={img_grammage} alt="" />
                                                    :''
                                                  }
                                                  </div>
                                                </div>
                                              </div>
                                              </div>
                                              <div className="modal-footer" style={{ textAlign: 'center', display: 'block', fontWeight: 'bolder', fontSize: '20px' }}>
                                                {
                                                  this.state.img_example == 'img_grammage'?
                                                  <>Tamaño 300 x 300</>
                                                  :''
                                                }
                                            </div>
                                        </Modal>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="product-physical">
                                        {this.renderResults()}
                                        {/*<VerGrammageDatatable
                                            multiSelectOption={false}
                                            myData={items}
                                            pageSize={5}
                                            pagination={false}
                                            class="-striped -highlight"
                                        />*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
            </Fragment>
        )
    }
}

export default Ver_grammage
